import * as React from 'react';
import Text from '../../../shared/Text';

interface Props {
  resetForm: () => void;
}

export default class LoginStepTotpInvalid extends React.Component<Props, {}> {
  resetForm = (e: React.FormEvent<any>) => {
    if (e && 'preventDefault' in e) {
      e.preventDefault();
    }
    if (typeof this.props.resetForm === 'function') {
      this.props.resetForm();
    }
  };

  render() {
    return (
      <form className="step-totp-invalid" data-test="login-form" name="loginFrm" onSubmit={this.resetForm}>
        <div className="form-control-wrapper">
          <h2 className="totp-code-headline">{Text.get('login_totp_invalid_headline')}</h2>
          <p className="totp-code-description">
            <span>{Text.get('login_totp_invalid_description')}</span>
          </p>
        </div>
        <div className="form-control-wrapper submit">
          <input
            autoFocus
            type="submit"
            data-test="retry"
            value={Text.get('login_button_retry')}
            className="btn btn-default btn-flat btn-customizable c42-orange c42-button"
          />
        </div>
      </form>
    );
  }
}
